import { retry } from "@reduxjs/toolkit/query"


export const getModuleColor = (moduleName) => {
    switch (moduleName) {
        case "CORE": return "#2bb673"
        case "ADMIN": return "orange"
        case "HR": return "gold"
        case "WHISTLE": return "orange"
        case "HEALTH": return "lightgreen"
        case "SAFETY": return "tomato"
        default: return "#FFFFFF"
    }
}